import {useEffect } from "react";
import DataLoader from "../../Utils/DataLoader";
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { HTTPURL} from "../../constants/matcher";
import { Link } from "react-router-dom";


const Lesson = () => 
{
    const [assignmentList, setAssignmentList] = useStateWithCallbackLazy([]);
    const [showResults, setShowResults] = useStateWithCallbackLazy(false);

    useEffect(() => 
    {
        const token = JSON.parse(localStorage.getItem("user-token"));
        const fetchAssignment = async() =>
        {
            try{
                return await fetch(HTTPURL+'user/get-all-assignments',{headers:{"Authorization" :`Bearer ${token}`} })
                .then((response) => response.json())
                .then((data) => {
                    setAssignmentList(data.data,() => setShowResults(true))
                });
            } catch(err) {
                console.log(err);
            }
        }
        fetchAssignment();
    },[]);
    return (
        <main>
            <div className="container-fluid px-4">
                <span className="heading mb-4">
                    <i className="fa fa-address-card"></i>
                    <label className="mt-4 mb-3">Attend Assessment</label>
                    <i className="fa fa-check-circle"></i><label className="">Completed Assesment</label>
                </span>
                <div className="row mb-4">
                    <div className="col-xl-12">
                        <div className="card mb-4">
                            <h4 className="card-header ">Completed Attendance</h4>
                            <div className="card-body mb-4">
                                {
                                    showResults ?
                                    assignmentList && assignmentList.map((assignment,index) => 
                                    {
                                        return (
                                            <div className="row mb-3" key={index}>
                                                <div className="col-md-10">
                                                    <Link to={"../lesson-details/"+assignment.id} title={assignment.lesson_name}>
                                                        <h6 className="card-title">{assignment.lesson_name}</h6>
                                                        <p className="card-text">Assesments duly submitted</p>
                                                    </Link>
                                                </div>
                                                <div className="col-md-2">
                                                    <span className="border border-success">100%</span>
                                                </div>
                                            </div>
                                        )
                                    })
                                    :
                                    <DataLoader />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Lesson;